/**
 * "Explain this": how the money a plan invests would be held (owner, 23 Oct 2026). Shown where the plan's card
 * says money is invested; the words are investedWhere.ts's, so the card and the note never disagree.
 */
import React from 'react';
import { howItIsInvestedWords } from '../../utils/investedWhere.ts';
import type { DraftFactFind } from '../../constants/initialFactFind.ts';

export const HowItIsInvestedNote = ({ factFind, testId = 'how-it-is-invested' }: { factFind: DraftFactFind | null | undefined; testId?: string }) => (
    <div className="mt-5 rounded-xl border border-slate-200 border-l-4 border-l-slate-400 bg-white px-4 py-3 text-[14px] leading-relaxed text-slate-700" data-testid={testId}>
        <p className="font-bold text-slate-900">How the invested money would be held</p>
        {howItIsInvestedWords(factFind as never).map((w, i) => <p key={i} className="mt-1">{w}</p>)}
    </div>
);

export default HowItIsInvestedNote;
